module.exports = __webpack_public_path__ + "img/shipment.ed5e8685.svg";